import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#0e0e0f] text-neutral-300">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center text-[#0e0e0f] font-semibold tracking-wider text-[13px]">
                STG
              </div>
              <span className="font-serif-display text-2xl text-white">STG</span>
            </div>
            <p className="mt-6 text-neutral-400 text-sm">Arhitectură • Design • Viziune</p>
            <p className="mt-2 text-neutral-500 text-sm">Strong Team Generation — din 2023.</p>
          </div>

          <div>
            <div className="text-[#f5b301] text-xs tracking-[0.28em] uppercase font-medium">Navigație</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#projects" className="hover:text-white transition-colors">Proiecte</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Servicii</a></li>
              <li><a href="#team" className="hover:text-white transition-colors">Echipa</a></li>
              <li><a href="#about" className="hover:text-white transition-colors">Studio</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[#f5b301] text-xs tracking-[0.28em] uppercase font-medium">Contact</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li>București • Cluj • Iași</li>
              <li><a href="tel:0729306119" className="hover:text-white transition-colors">0729 306 119</a></li>
              <li><a href="mailto:dumitruramonaionela75@gmail.com" className="hover:text-white transition-colors break-all">dumitruramonaionela75@gmail.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-neutral-500">
          <div>© 2026 Strong Team Generation. Toate drepturile rezervate.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white transition-colors">Termeni</a>
            <a href="#" className="hover:text-white transition-colors">Confidențialitate</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
